import { createColumnHelper } from "@tanstack/react-table";
import { format } from "date-fns";
import { comissionPercentage } from "../../../../../../app/utils/comissionPercentage";
import { formatMoneyValue } from "../../../../../../app/utils/formatMoneyValue";
import { Transaction } from "../../../../../../app/entities/Transaction";
import { BasicAvatar } from "../../../../../components/BasicAvatar";
import Status from "../../../../../components/Status";
import { onlyFirstName } from "@/app/utils/onlyFirstName";
import { getImageByType } from "@/app/utils/getImageByType";

const columnHelper = createColumnHelper<Transaction>();

const columns = [
  columnHelper.accessor("contract", {
    id: "contract",
    header: () => (
      <div className="flex flex-col items-start pl-2 xl:items-center xl:pl-0">
        <div>Contrato</div>
        <div className="block text-black04 xl:hidden">Vendedor</div>
      </div>
    ),
    cell: ({ row }) => (
      <div className="flex flex-col items-start pl-4 xl:items-center xl:pl-0">
        <div>{row.original.contract}</div>
        <div className="block text-black04 xl:hidden">
          <p className="text-black04">
            {row.original?.seller?.name
              ? onlyFirstName(row.original.seller.name)
              : "N/A"}
          </p>
          <p className="text-black04">{row.original.team?.name || ""}</p>
        </div>
      </div>
    ),
  }),
  columnHelper.accessor("type", {
    id: "type",
    header: () => <div className="hidden pl-2 text-left xs:block">Produto</div>,
    cell: ({ row }) => {
      const type = row.original.type;
      const imageSrc = getImageByType(type);

      return (
        <div className="hidden items-center justify-start pl-6 text-left xs:flex">
          <img
            src={imageSrc}
            className="mb-1 h-8 w-8 rounded-lg object-contain"
            alt={type}
          />
        </div>
      );
    },
  }),
  columnHelper.accessor("customer", {
    id: "customer",
    header: () => <div className="hidden text-left xs:block">Cliente</div>,
    cell: ({ row }) => (
      <div className="hidden text-left xs:block">
        {row.original?.customer?.name
          ? onlyFirstName(row.original.customer.name)
          : ""}
      </div>
    ),
  }),
  columnHelper.accessor("value", {
    id: "value",
    header: () => (
      <div className="flex flex-col items-end pr-2 xs:items-center xs:pr-0">
        <div>Valor</div>
        <div className="block text-black04 lg:hidden">Data</div>
      </div>
    ),
    cell: ({ row }) => (
      <div className="flex flex-col items-end pr-4 xs:items-center xs:pr-0">
        <div>{formatMoneyValue(row.original.value)}</div>
        <div className="block text-black04 lg:hidden">
          {format(row.original.createdAt, "dd/MM/yyyy, HH:mm")}
        </div>
      </div>
    ),
  }),
  columnHelper.accessor("commission", {
    id: "comission",
    header: () => <div className="hidden text-center sm:block">Comissão</div>,
    cell: ({ row }) => {
      const isSalvcar = row.original.table?.name?.toLowerCase().includes("salvcar");
      return (
        <div className="hidden text-center sm:block">
          {formatMoneyValue(row.original.commission)}{" "}
          {!isSalvcar && comissionPercentage(row.original.value, row.original.commission)}
        </div>
      );
    },
  }),

  columnHelper.accessor("seller", {
    id: "vendedor",
    header: () => (
      <div className="hidden lg:block">
        <div className="text-left">Vendedor</div>
      </div>
    ),
    cell: ({ row }) => (
      <div className="hidden lg:block">
        <div className="flex items-center gap-2">
          <BasicAvatar
            name={row.original?.seller?.name || ""}
            profileImageUrl={row.original?.seller?.profileImageUrl || ""}
          />
          <div className="flex flex-col gap-1">
            <p>
              {row.original?.seller?.name
                ? onlyFirstName(row.original.seller.name)
                : "N/A"}
            </p>
            <p className="text-black04">{row.original.team?.name || ""}</p>
          </div>
        </div>
      </div>
    ),
  }),
  columnHelper.accessor("createdAt", {
    id: "data",
    header: () => <div className="hidden text-center xl:block">Data</div>,
    cell: ({ row }) => (
      <div className="hidden text-center xl:block">
        {format(row.original.createdAt, "dd/MM/yyyy, HH:mm")}
      </div>
    ),
  }),
  columnHelper.accessor("actualStatus", {
    id: "actualStatus",
    header: () => <div className="hidden text-center md:block">Status</div>,
    cell: ({ row }) => (
      <div className="hidden md:block">
        <Status status={row.getValue("actualStatus")} />
      </div>
    ),
  }),
];

export const TableColumsDefinition = () => {
  return {
    columns,
  };
};
